export default __webpack_public_path__ + "static/media/image 18.05425b3c.png";